import { Button, styled, Typography } from "@material-ui/core";

export const TTLContainer = styled("div")(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
}));

export const TTLContentWrapper = styled("div")(({ theme }) => ({
  paddingBottom: theme.spacing(16),
  paddingTop: theme.spacing(12),
  padding: theme.spacing(4),
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: "1140px",
  display: "flex",
}));

export const TTLTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.h3.fontSize,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(5),
  textAlign: "center",
}));

export const TTLSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h6.fontSize,
  marginBottom: theme.spacing(5),
  textAlign: "center",
  minWidth: "200px",
  width: "65%",
}));

export const TTLElementContainer = styled("div")(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  padding: theme.spacing(3.5),
  justifyContent: "center",
  borderRadius: "0.35rem",
  flexDirection: "column",
  alignItems: "center",
  display: "flex",
  width: "300px",
}));

export const TTLElements = styled("div")(({ theme }) => ({
  justifyContent: "center",
  alignItems: "stretch",
  display: "flex",

  "& > div:not(:last-child)": {
    marginRight: "1rem",
  },

  [`${theme.breakpoints.down("sm")}`]: {
    flexDirection: "column",

    "& > div:not(:last-child)": {
      marginBottom: "1rem",
      marginRight: 0,
    },
  },
}));

export const TTLElementTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.h6.fontSize,
  marginBottom: theme.spacing(2),
  textAlign: "center",
}));

export const TTLElementDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  marginBottom: theme.spacing(2.5),
  textAlign: "center",
}));

export const TTLElementButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  textTransform: "capitalize",
  padding: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  minWidth: "150px",

  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },

  "&:focus": {
    outline: "0 !important",
    border: "0 !important",
  },
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitLanding/TeachersToolkitLanding.styled.js